import React, { useEffect, useRef } from 'react'
import { Card } from 'antd'
import * as echarts from 'echarts'

const TestChart: React.FC = () => {
  const chartRef = useRef<HTMLDivElement>(null)
  const chartInstance = useRef<echarts.ECharts | null>(null)

  useEffect(() => {
    console.log('TestChart useEffect triggered')
    console.log('chartRef.current:', chartRef.current)
    console.log('echarts:', echarts)

    if (chartRef.current && !chartInstance.current) {
      try {
        console.log('Initializing ECharts...')
        chartInstance.current = echarts.init(chartRef.current)
        console.log('ECharts initialized:', chartInstance.current)

        const option = {
          title: {
            text: '测试图表'
          },
          tooltip: {},
          xAxis: {
            data: ['衬衫', '羊毛衫', '雪纺衫', '裤子', '高跟鞋', '袜子']
          },
          yAxis: {},
          series: [{
            name: '销量',
            type: 'bar',
            data: [5, 20, 36, 10, 10, 20]
          }]
        }

        chartInstance.current.setOption(option)
        console.log('Chart option set successfully')
      } catch (error) {
        console.error('ECharts initialization error:', error)
      }
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.dispose()
        chartInstance.current = null
      }
    }
  }, [])

  return (
    <div style={{ padding: '24px' }}>
      <Card title="ECharts 测试">
        <div 
          ref={chartRef} 
          style={{ 
            width: '100%', 
            height: '400px',
            border: '1px solid #ccc',
            backgroundColor: '#f5f5f5'
          }} 
        />
      </Card>
    </div>
  )
}

export default TestChart
